export default {
    get current_variant_selling_plan_allocations() {
        const currentSubscriptionVariant = this.currentSubscriptionVariant;
        if (!currentSubscriptionVariant) {
            return [];
        }

        const selling_plan_allocations = currentSubscriptionVariant?.selling_plan_allocations;
        if (!selling_plan_allocations) {
            return [];
        }

        if (!selling_plan_allocations?.length) {
            return [];
        }

        return selling_plan_allocations;
    },

    get current_variant_selling_plans() {
        const {current_variant_selling_plan_allocations} = this;
        if (!current_variant_selling_plan_allocations) {
            return [];
        }

        if (!current_variant_selling_plan_allocations?.length) {
            return [];
        }

        const current_variant_selling_plans = current_variant_selling_plan_allocations?.map((selling_plan_allocation) => {
            return selling_plan_allocation?.selling_plan;
        })?.filter((selling_plan) => {
            return !!selling_plan;
        }) || [];

        if (!current_variant_selling_plans) {
            return [];
        }

        if (!current_variant_selling_plans?.length) {
            return [];
        }

        return current_variant_selling_plans;
    },

    get current_variant_selected_selling_plan() {
        const selling_plan_id = this.selling_plan_id;
        if (!selling_plan_id) {
            return null;
        }

        const current_variant_selling_plans = this.current_variant_selling_plans;
        if (!current_variant_selling_plans) {
            return null;
        }

        if (!current_variant_selling_plans?.length) {
            return null;
        }

        const selected_selling_plan = current_variant_selling_plans?.find((selling_plan) => {
            return selling_plan?.id === selling_plan_id;
        }) || [];

        if (!selected_selling_plan) {
            return null;
        }

        return selected_selling_plan;
    },

    get current_variant_selected_selling_plan_price_adjustments() {
        const current_variant_selected_selling_plan = this.current_variant_selected_selling_plan;
        if (!current_variant_selected_selling_plan) {
            return [];
        }

        const price_adjustments = current_variant_selected_selling_plan?.price_adjustments;
        if (!price_adjustments) {
            return [];
        }

        if (!price_adjustments?.length) {
            return [];
        }

        return price_adjustments;
    },

    get price_adjustments_value() {
        const {current_variant_selected_selling_plan_price_adjustments} = this;
        if (!current_variant_selected_selling_plan_price_adjustments) {
            return 0;
        }

        if (!current_variant_selected_selling_plan_price_adjustments?.length) {
            return 0;
        }

        const current_variant_first_selected_selling_plan_price_adjustment = current_variant_selected_selling_plan_price_adjustments[0];
        if (!current_variant_first_selected_selling_plan_price_adjustment) {
            return 0;
        }

        const discount = current_variant_first_selected_selling_plan_price_adjustment?.value || 0.0;

        const member_pricing_available = this.member_pricing_available;
        if (!member_pricing_available) {
            return discount;
        }

        return parseFloat(((1 - (1 - discount / 100) * this.current_member_discount_multiplier) * 100).toFixed(2));
    },

    get current_discount() {
        return this.price_adjustments_value;
    },

    get current_discount_multiplier() {
        const current_discount = this.current_discount;

        if (!current_discount) {
            return 0;
        }

        return 1 - current_discount / 100.0;
    },

    get next_discount() {
        return this.price_adjustments_value;
    },

    get next_discount_multiplier() {
        const next_discount = this.next_discount;
        if (!next_discount) {
            return 1;
        }

        return 1 - next_discount / 100;
    },

    get next_member_discount() {
        const next_discount = this.next_discount;
        if (!next_discount) {
            return 0;
        }

        const current_member_discount_multiplier = this.current_member_discount_multiplier;
        if (!current_member_discount_multiplier) {
            return next_discount;
        }

        return ((1 - this.next_discount_multiplier * current_member_discount_multiplier) * 100).toFixed(2);
    },

    get max_discount() {
        return this.price_adjustments_value;
    },

    get discount_multiplier() {
        const {current_discount} = this;
        if (!current_discount) {
            return 1.0;
        }

        return 1.0 - current_discount / 100.0;
    },

    get max_discount_multiplier() {
        const current_discount = this.max_discount;
        if (!current_discount) {
            return 1.0;
        }

        return 1.0 - current_discount / 100.0;
    },

    get product_discount_percent() {
        // Shop metafield kill-switch (absolute.settings.metafieldDiscountEnabled).
        // Liquid already hides the discount when this is off; without the same check
        // here display.js would rewrite the price nodes from these getters and
        // silently re-apply it on the next variant change.

        console.log(
            'dataset?.productDiscountsEnabled',
            this.container?.dataset?.productDiscountsEnabled
        );

        if (this.container?.dataset?.productDiscountsEnabled !== 'true') {
            return 0;
        }

        // Both metafields are consulted: a variant value wins only when it is an
        // actual discount. Unset *and* 0 both fall back to the product-level value.
        const variantValue = Number(
            this.currentVariant?.metafields?.price?.discount ?? 0
        );
        const productValue = Number(
            this.product?.metafields?.price?.discount ?? 0
        );

        console.log('currentVariant', this.currentVariant);
        console.log('variantValue', variantValue);

        const raw = variantValue > 0 ? variantValue : productValue;
        if (!Number.isFinite(raw) || raw <= 0 || raw >= 100) {
            return 0;
        }

        return raw;
    },

    get has_product_discount() {
        return this.product_discount_percent > 0;
    },

    // The member's effective one-time price. With the metafield discount active the
    // member sees the discounted price -- deriving it from the undiscounted base makes
    // the member price higher than the public one.
    get current_member_price() {
        if (this.has_product_discount) {
            return this.current_price;
        }

        return this.current_base_price * this.current_member_discount_multiplier;
    },

    get product_discount_multiplier() {
        const percent = this.product_discount_percent;

        return percent ? 1 - percent / 100 : 1;
    },

    // The undiscounted one-time price. Member and subscription pricing derive from
    // this so the product discount metafield never compounds with them.
    get current_base_price() {
        const {currentVariant} = this;
        if (!currentVariant) {
            return null;
        }

        return currentVariant?.price || 0;
    },

    get current_price() {
        const {currentVariant} = this;
        if (!currentVariant) {
            return null;
        }

        const price = currentVariant?.price;
        if (!price) {
            return 0;
        }

        console.log(
            'product_discount_multiplier',
            this.product_discount_multiplier
        );

        if (this.has_product_discount) {
            return price * this.product_discount_multiplier;
        }

        return price;
    },

    get compare_at_price() {
        const {currentVariant} = this;
        if (!currentVariant) {
            return null;
        }

        const price = currentVariant?.compare_at_price;

        // A product discount strikes through the highest anchor available: the
        // native compare-at when there is one, otherwise the undiscounted price.
        if (this.has_product_discount) {
            return Math.max(Number(price) || 0, Number(currentVariant?.price) || 0);
        }

        if (!price) {
            return 0;
        }

        return price;
    },

    get current_subscription_price() {
        const {currentSubscriptionVariant} = this;
        if (!currentSubscriptionVariant) {
            return 0;
        }

        const price = currentSubscriptionVariant?.price;

        if (!price) {
            return 0;
        }

        const discount_multiplier = this.current_discount_multiplier;

        if (!discount_multiplier) {
            return price;
        }

        return price * discount_multiplier;
    },

    get current_member_subscription_price() {
        const current_subscription_price = this.current_subscription_price;
        if (!current_subscription_price) {
            return 0;
        }

        const member_pricing_available = this.member_pricing_available;
        if (!member_pricing_available) {
            return current_subscription_price;
        }

        const current_member_discount_multiplier = this.current_member_discount_multiplier;
        if (!current_member_discount_multiplier) {
            return current_subscription_price;
        }

        return current_subscription_price * current_member_discount_multiplier;
    },

    get next_subscription_price() {
        const currentSubscriptionVariant = this.currentSubscriptionVariant;
        if (!currentSubscriptionVariant) {
            return 0;
        }

        const price = currentSubscriptionVariant?.price;
        if (!price) {
            return 0;
        }

        const discount_multiplier = this.next_discount_multiplier;
        if (!discount_multiplier) {
            return price;
        }

        return price * discount_multiplier;
    },

    get next_member_subscription_price() {
        const next_subscription_price = this.next_subscription_price;
        if (!next_subscription_price) {
            return 0;
        }

        return next_subscription_price;
    },

    get min_subscription_price() {
        const {currentSubscriptionVariant} = this;
        if (!currentSubscriptionVariant) {
            return null;
        }

        const price = currentSubscriptionVariant?.price;
        if (!price) {
            return 0;
        }

        const discount_multiplier = this.max_discount_multiplier;
        if (!discount_multiplier) {
            return price;
        }

        return price * discount_multiplier;
    },

    get min_member_subscription_price() {
        const min_subscription_price = this.min_subscription_price;
        if (!min_subscription_price) {
            return 0;
        }

        const member_pricing_available = this.member_pricing_available;
        if (!member_pricing_available) {
            return min_subscription_price;
        }

        const current_member_discount_multiplier = this.current_member_discount_multiplier;
        if (!current_member_discount_multiplier) {
            return min_subscription_price;
        }

        return min_subscription_price * current_member_discount_multiplier;
    },

    get member_discount() {
        const lashSettings = this.lashSettings;
        if (!lashSettings) {
            return 0.0;
        }

        const memberDiscountsEnabled = lashSettings?.memberDiscountsEnabled;
        if (!memberDiscountsEnabled) {
            return 0.0;
        }

        const memberDiscountValue = lashSettings?.memberDiscountValue;
        if (!memberDiscountValue) {
            return 0.0;
        }

        return memberDiscountValue / 100.0;
    },

    get current_member_discount_multiplier() {
        const member_discount = this.member_discount;
        if (!member_discount) {
            return 1.0;
        }

        return 1 - member_discount;
    },

    get combines_with_member_discount() {
        return false;
    },

    get member_pricing_available() {
        const member_discount = this.member_discount;
        if (!member_discount) {
            return false;
        }

        const isRetail = this.isRetailProduct;
        if (!isRetail) {
            return false;
        }

        if (!this.combines_with_member_discount) {
            return false;
        }

        const frequency = this.frequency;
        if (!frequency) {
            return false;
        }

        return !![
            !!this.isActiveSubscriber,
            !!this.membership_already_in_cart,
        ]?.includes(true);
    },
};
